import { BaseClient } from "../../Api/HttpClient";
import toast from "react-hot-toast";
import i18next from "i18next";

export const createBranchPercentageSlice = (set, get) => ({
    branchPercentages: [],

    getBranchPercentages: async (branchId) => {
        try {
            const response = await BaseClient().get(`/percentages/branch/${branchId}`);
            if (response.status === 200) {
                const data = response.data.data || response.data;
                set({ branchPercentages: data });
                return data;
            }
        } catch (error) {
            console.error('Error fetching branch percentages', error);
            toast.error(i18next.t('branch_percentages.toast_fetch_error'));
        }
    },

    updateBranchPercentages: async (branchId, percentages) => {
        try {
            const response = await BaseClient().post(`/percentages/branch/${branchId}`, {
                percentages: percentages
            });
            if (response.status === 200) {
                const data = response.data.data || response.data;
                set({ branchPercentages: data });
                toast.success(i18next.t('branch_percentages.toast_save_success'));
                return data;
            }
        } catch (error) {
            console.error('Error updating branch percentages', error);
            if (error?.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error(i18next.t('branch_percentages.toast_save_error'));
            }
            throw error;
        }
    },
});

